var $ = global.jQuery = global.$;
var _Base = require('./_Base');
var parser = require('../lib/parser');

/**
 * Mobile navigation widget
 * @class
 * @extends _Base
 */
var MultiOverlay = _Base.extend(
  /** @lends MultiOverlayItem.prototype */
  {
    /**
     * Initialisation method
     * @private
     */
    init: function() {
      var self = this,
        template = require('../templates/overlay.dot');

      this.items = [];
      this.itemCount = 0;

      this.$el.append(template({}));

      this.$next = this.$el.find('[data-overlay-next]');
      this.$prev = this.$el.find('[data-overlay-prev]');
      this.$close = this.$el.find('[data-overlay-close]');
      this.$content = this.$el.find('[data-overlay-content]');
      this.snapTo = 0;

      this.$el.hide();

      this.$next.on('click', function(event) {
        event.preventDefault();
        self.open(self.currentIndex + 1);
      });
      this.$prev.on('click', function(event) {
        event.preventDefault();
        self.open(self.currentIndex - 1);
      });
      this.$close.on('click', function(event) {
        event.preventDefault();
        self.close();
      });
    },
    open: function(index) {
      var self = this;
      if (!this.items[index] && index >= 0) index = 0;
      if (index < 0) index = this.items.length - 1;

      if (!this.isOpen) {
        this.$el.velocity('fadeIn',{
          complete: function() {
            self.snapTo = $(window).scrollTop();
            $('body').css({
              position: 'fixed',
              height: '100%',
              width: '100%',
              overflowY: 'scroll'
            });
          }
        });
      }
      this.$content.height(this.$content.height());
      this.$content.empty();

      if (!this.items[index].renderedHtml) {
        this.items[index].getItemData(function() {
          var $content = $(this.items[index].renderedHtml);
          $content.hide();
          this.$content.append($content);
          parser.parse(this.$content);
          $content.velocity('fadeIn', {
            delay: 300,
            complete: function() {
              self.$content.removeAttr('style');
            }
          });
        }.bind(this));
      } else {
        this.$content.append(this.items[index].renderedHtml);
        parser.parse(this.$content);
        this.$content.removeAttr('style');
      }

      this.isOpen = true;
      this.currentIndex = index;

    },
    close: function() {
      var self = this;
      if (this.isOpen) {
        this.isOpen = false;
        $('body').removeAttr('style');
        $(window).scrollTop(this.snapTo);
        this.$el.velocity('fadeOut');
      }
    },
    addItem: function(item) {
      this.items.push(item);

      return this.itemCount++;
    }
  });

module.exports = MultiOverlay;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/MultiOverlay.js
// module id = 305
// module chunks = 0